export default {
  hypotheeknummer: "Hypotheeknummer",
};
